import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyFeedTypes } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_FEED_TYPES } from "consts";

import { DairyFeedTypes, WithInjectedName } from "models";

export const useGetDairyFeedTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });

  return useQuery<Array<WithInjectedName<DairyFeedTypes>>>({
    queryKey: [GET_DAIRY_FEED_TYPES, { enabled }],
    queryFn: async () => {
      const feedTypes = await getDairyFeedTypes({ enabled });
      return feedTypes.map((ft) => ({ ...ft, name: t(`feedTypes.${ft.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
